import { render, staticRenderFns } from "./SliderIconStyles.vue?vue&type=template&id=271fde3a&scoped=true&lang=pug&"
import script from "./SliderIconStyles.vue?vue&type=script&lang=ts&"
export * from "./SliderIconStyles.vue?vue&type=script&lang=ts&"
import style0 from "./SliderIconStyles.vue?vue&type=style&index=0&id=271fde3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271fde3a",
  null
  
)

export default component.exports